// extracted by mini-css-extract-plugin
export default {"footerBg":"Y-z","footerTopLinks":"Z-z","footerFeedback":"_-z","footerSocial":"aa-z","footerLegalLinks":"ba-z","footerIconCards":"ca-z","footerBotCopy":"da-z"};